var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPlayIcon = function SvgPlayIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 23 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    stroke: "currentColor",
    d: "M1.06.3A2.15 2.15 0 0 0 0 2.143v19.714c0 .755.406 1.457 1.06 1.843a2.18 2.18 0 0 0 2.142.037l18.173-9.857A2.14 2.14 0 0 0 22.5 12c0-.782-.433-1.505-1.125-1.88L3.202.263A2.18 2.18 0 0 0 1.06.3Zm1.536 20.834V2.866L19.433 12z"
  })));
};
export default SvgPlayIcon;